// Every translation namespace under public/locales/<lng>/. i18n.ts preloads
// them all at init so no component ever suspends on a lazily-loaded namespace
// after the first commit — a post-commit suspension bubbles to the root
// <Suspense> boundary, which unmounts/remounts the whole tree and re-fires
// every bootstrap effect (duplicate settings/components/announcements
// requests on first load).
//
// Kept in sync with the locale folders by tests/i18nNamespaces.test.ts.
export const I18N_NAMESPACES = [
  'affiliate',
  'affiliatePolicy',
  'announcementModal',
  'blogs',
  'cashier',
  'casino',
  'claimHistory',
  'commission',
  'common',
  'contactUs',
  'downloadPwa',
  'drawer',
  'duplicateAccount',
  'feedback',
  'financialTransaction',
  'footer',
  'freeBonus',
  'freeSpin',
  'homeV2',
  'inbox',
  'kyc',
  'kyc2',
  'login',
  'loginBonus',
  'personalData',
  'promotions',
  'raffle',
  'recoverPassword',
  'redeemBonus',
  'referral',
  'referralPolicy',
  'register',
  'survey',
  'topAd',
  'verification',
  'vip',
  'vipCenter',
  'wageringTransaction',
  'walletManagement',
] as const
